// extracted by mini-css-extract-plugin
export var addToCartButton = "_t5-b";
export var arrowButtonContainer = "_t5-9";
export var arrowButtonIcon = "_t5-a";
export var carouselArrowButton = "_t5-6";
export var carouselElementContainer = "_t5-1";
export var left = "_t5-7";
export var productDisplayCarouselContainer = "_t5-0";
export var productTileContainer = "_t5-2";
export var productTileImage = "_t5-4";
export var productTileImageContainer = "_t5-3";
export var productTileTitle = "_t5-5";
export var right = "_t5-8";
export var sliderOverflow = "_t5-c";